import type { Chart } from '../types'
import { plural } from '../format'

// Accessible representation of a chart (AUDIT D-a11y / #7). recharts renders to SVG
// with no machine-readable data, so the chart is marked aria-hidden and these pure
// helpers drive an off-screen data table + a summarising label. Kept pure so the
// guarantee (every datum + series exposed) is unit-testable without rendering recharts.

export function chartAriaLabel(chart: Chart): string {
  return `${chart.type} chart, ${chart.unit}, ${chart.data.length} ${plural(chart.data.length, 'row')}`
}

export interface A11yTable {
  columns: string[] // header labels (after the category column)
  rows: { head: string; cells: string[] }[]
}

export function chartTable(chart: Chart): A11yTable {
  const series = chart.series && chart.series.length ? chart.series : ['value']
  const columns = series.map((s) => (s === 'value' ? chart.unit : s))
  const rows = chart.data.map((d, i) => ({
    head: String(d.name ?? i),
    cells: series.map((s) => String(d[s] ?? '')),
  }))
  return { columns, rows }
}
